import { PasswordEntry } from "./PasswordEntry";

export default PasswordEntry;